import { Api } from '../helpers';

const reasonModel = {
  getReasons(url, params) {
    const queryParams = params;
    const path = url;
    return Api.get({ path, queryParams });
  },

  getMacResponse(reason_id, data) {
    const path = `issues/raise_issue/${reason_id}/get_mac_state`;
    const body = data;
    return Api.post({ path }, { body });
  },

  getIssuesInfo(url, data, v2data) {
    let path = '';
    path = url ? `issues/raise_issue/${url}` : `/issues/v2/raise_issue`;
    const body = url ? data : v2data;
    return Api.post({ path }, { body });
  },

  sendFormData(url, reason_id, data) {
    const path = `issues/raise_issue/${reason_id}/${url}`;
    const body = data;
    return Api.post({ path }, { body });
  },

  evaluateResolution(data, slug = 'evaluate') {
    const path = `/issues/v2/raise_issue/${slug}`;
    const body = data;
    return Api.post({ path }, { body });
  },

  createResolution(data, slug = 'resolve') {
    let path = '';
    path = `/issues/v2/raise_issue/${slug}`;
    const body = data;
    return Api.post({ path }, { body });
  },

  getAllIssues(order_id) {
    const path = `issues/v2/${order_id}/get_all_issues`;
    return Api.get({ path });
  },

  getComplaintImages(orderId, sessionId = null) {
    const path = `complaint_media/get`;
    const queryParams = {
      order_id: orderId,
    };
    return Api.get({ path, queryParams });
  },

  deleteComplaintImages(mediaId) {
    const path = `complaint_media/delete`;
    const queryParams = {
      media_id: mediaId,
    };
    return Api.delete({ path, queryParams });
  },

  getReundOptionInCancelOrderFlow(reasonId, slug, orderId, key, value) {
    const path = `/issues/raise_issue/${reasonId}/${slug}`;
    const body = {
      order_id: orderId,
      [`${key}`]: value,
    };
    return Api.post({ path }, { body });
  },
};

export default reasonModel;
